import { memo } from "react";

interface WebpImageProps {
  srcWebp: string;
  srcFallback: string;
  fallbackType: "png" | "jpg" | "jpeg";
  alt: string;
  lazyLoad?: boolean;
  className?: string;
  width?: string | number;
  height?: string | number;
}

const WebpImage = ({
  srcWebp,
  srcFallback,
  fallbackType,
  alt,
  lazyLoad,
  className,
  width,
  height,
}: WebpImageProps) => {
  return (
    <picture>
      <source srcSet={srcWebp} type="image/webp" />
      <source srcSet={srcFallback} type={`image/${fallbackType}`} />
      <img
        src={srcFallback}
        alt={alt}
        loading={lazyLoad ? "lazy" : "eager"}
        className={className}
        width={width}
        height={height}
      />
    </picture>
  );
};

export default memo(WebpImage);
